import { createSlice } from '@reduxjs/toolkit';

import {
  getOrdersOverviewReducers,
  getOrdersReducers,
  getOrderByIdReducers,
  ordersSyncReducers,
  ordersSettingsReducers,
} from './orders.reducers';

const initialState = {
  overview: null,
  orders: [],
  totalOrders: 0,
  totalPages: 1,
  currentPage: 1,
  currentOrder: null,
  settings: null,
  syncStatus: null,
  syncRunning: false,
  syncProgress: null,

  getOverviewStatus: 'idle',
  getOrdersStatus: 'idle',
  getOrderByIdStatus: 'idle',
  startSyncStatus: 'idle',

  error: null,
};

const ordersSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    setOrdersSyncProgress(state, { payload }) {
      state.syncProgress = payload;
      state.syncRunning = payload?.status === 'running';
    },
    clearOrdersError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    getOrdersOverviewReducers(builder);
    getOrdersReducers(builder);
    getOrderByIdReducers(builder);
    ordersSyncReducers(builder);
    ordersSettingsReducers(builder);
  },
});

export const { setOrdersSyncProgress, clearOrdersError } = ordersSlice.actions;
export default ordersSlice.reducer;
